import { render, staticRenderFns } from "./PostalCode.vue?vue&type=template&id=b8d00ffe&"
import script from "./PostalCode.vue?vue&type=script&lang=js&"
export * from "./PostalCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8d00ffe')) {
      api.createRecord('b8d00ffe', component.options)
    } else {
      api.reload('b8d00ffe', component.options)
    }
    module.hot.accept("./PostalCode.vue?vue&type=template&id=b8d00ffe&", function () {
      api.rerender('b8d00ffe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/form/text/PostalCode.vue"
export default component.exports